import React from 'react';

import DatePickerTag4 from '@/components/common/DatePicker/DatePickerTag4';
import TopLabel from '@/components/common/TopLabel/TopLabel';

import { IModalFormProps } from '../ModalFormProps.interface';

import './modal-form-datepicker.scss';


interface IModalFormDatepickerProps extends IModalFormProps {
  id: string;
  value?: Date | null;
  onChange?: ({ value }: { value: Date | null }) => void;
  disabled?: boolean;
  placeholder?: string;
}

export default function ModalFormDatepicker({
  id,
  className,
  labelTitle,
  requiredIcon,
  validationMessage,
  disabled,
  value,
  onChange,
  placeholder,
}: IModalFormDatepickerProps) {
  return (
    <div className={className}>
      {labelTitle && (
        <TopLabel
          id={id}
          label={labelTitle}
          required={requiredIcon}
        />
      )}

      <DatePickerTag4
        id={id}
        value={value}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder }
      />
      {validationMessage && (
        <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
          {validationMessage}
        </div>
      )}
    </div>
  );
}
